import { useZone, ZoneParams } from "../api/zones";

import { CmsWidget } from "./cms-widget";

export type CmsZoneProps = {
  pageType: string;
  selectionKey: string;
  zoneId: string;
  experiments?: string;
};

export function CmsZone({ pageType, selectionKey, zoneId, experiments }: CmsZoneProps) {
  const zoneParams: ZoneParams = {
    pageType: pageType,
    selectionKey: selectionKey,
    zoneId: zoneId,
  };
  const { data } = useZone(zoneParams);
  if (!pageType || !zoneId) {
    return null;
  }

  return (
    <CmsWidget
      zoneParams={zoneParams}
      experiments={experiments}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      zone={data as any}
    />
  );
}
